<template>
  <div>
    <div v-if="selectedReport === 'all-order'">
      <report-downloads-table
        :key="selectedReport"
      />
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions,camelcase
import Ripple from 'vue-ripple-directive'
// eslint-disable-next-line import/extensions
import ReportDownloadsTable from '@/views/reports/Downloads/ReportDownloadsTable.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    ReportDownloadsTable,
  },
  data() {
    return {
      selectedReport: '',
    }
  },
  mounted() {
    this.getKey()
  },
  methods: {
    getKey() {
      this.selectedReport = this.$route.params.key
    },
  },
}
</script>

<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select';
</style>
